'use client';

import { PropsWithChildren, createContext, useContext } from 'react';

const MapKitJsTokenContext = createContext<string | null>(null);

export function useMapKitJsToken() {
  const token = useContext(MapKitJsTokenContext);

  if (!token) {
    throw new Error(
      'useMapKitJsToken must be used within a <MapKitJsTokenProvider>',
    );
  }

  return token;
}

interface Props {
  value: string;
}

export default function MapKitJsTokenProvider({
  value,
  children,
}: PropsWithChildren<Props>) {
  return (
    <MapKitJsTokenContext.Provider value={value}>
      {children}
    </MapKitJsTokenContext.Provider>
  );
}
